export const pageSize = 10;
export const orderType = "desc";
export const bGId = "d17f28af-5e82-4ba9-b5bf-685dadfbf5e3";
export const APIId = "227f28af-5e82-4ba9-b5bf-685dadfbf5e3";
export const bankId = "92e67d45-b4d4-4710-a6b9-bde2b5de5b5a";

export const getRoutes = [
  {
    path: "/",
    name: "Activity",
    component: "activities/Activities",
  },
  {
    path: "/user-management",
    name: "User management",
    component: "userManagement/UserManagement",
  },
  {
    path: "/owned-products",
    name: "OwnProducts",
    component: "ownProducts/OwnProducts",
  },
  {
    path: "/billing",
    name: "Billing",
    component: "billing/Billing",
  },
  {
    path: "/user-management/add-user",
    name: "AddUser",
    component: "userManagement/addUser/AddUser",
  },
];

export const getLocalRoutes = [{ path: "/login", component: "login" }];
export const activitiesFiltersList = [
  { label: "1 D.", key: "1" },
  { label: "5 D.", key: "2" },
  { label: "1 M.", key: "3" },
  { label: "6 M.", key: "4" },
  { label: "YTD", key: "5" },
  { label: "1 Y.", key: "6" },
  { label: "5 Y.", key: "7" },
  { label: "MAX.", key: "8" },
];

export const nonAuthRoutes = [
  "/",
  "/gecco",
  "/futurecare",
  "/digitalsolution",
  "/imprint",
  "/uber-uns",
];

export const ROLES = {
  branch_admin: "#EA",
  internal_admin: "#IA",
  branch_consultant: "#EC",
  end_user: "#EU",
  api_user: "#AU",
};
export const bankProducts = [
  { value: 2, key: "4197de32-f676-4144-a688-52580fa10fa6", name: "Gecco" }, // gitleaks:allow
  { value: 3, key: "9432debc-37d8-444d-a4bf-debf7e6603ce", name: "FutureCare" }, // gitleaks:allow
];
export const getIcon = {
  gecco: "/assets/icons/Gecco.png",
  futurecare: "/assets/icons/FutureCare.png",
  vds: "/assets/icons/Vds.png",
};

export const REGEX = {
  bic: /^([A-Z]{4}(?:-?[A-Z]{2}){2}-?[A-Z0-9]{3})?$/,
  iban: /^([A-Z]{2}\d{2}(?:\s?\d{4}){3}\s?[\d]{2})?$/,
  accountHolder: /^[A-Za-z\s'-]{0,100}$/,
};
export const INTERNAL_ADMIN = "#IA";
export const BRANCH_ADMIN = "#EA";
export const BRANCH_CONSULTANT = "#EC";
export const END_USER = "#EU";
export const API_USER = "#AU";

export const inputLabelStyles = {
  color: "#00000080 !important",
  fontSize: "0.89rem",
  fontWeight: "600",
  lineHeight: "1.5rem",
  fontFamily:
    'system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" ',
  "&.Mui-focused": {
    fontWeight: "500",
    color: "#000000 !important",
  },
};
export const customStyle = {
  ".css-dncllk-MuiInputBase-root-MuiFilledInput-root": {
    borderRadius: "0 !important",
  },
  ".css-1q7k2fz-MuiInputBase-root-MuiFilledInput-root ": {
    paddingTop: "16px",
  },

  "&.MuiTextField-root": {
    minWidth: "auto !important",
    maxWidth: "100% !important",
  },
  "@media screen and (max-width: 992px)": {
    width: "100%",
    margin: "10px 0",
  },
};
export const productId = "89F6A985-4B94-49BA-A4EF-629A781BD7D1";
export const StatusList = [
  {
    label: "active",
    value: "true",
  },
  {
    label: "deactive",
    value: "false",
  },
];
export const productsList = [
  {
    id: "4197de32-f676-4144-a688-52580fa10fa6", // gitleaks:allow
    name: "Gecco2",
  },
  {
    id: "9432debc-37d8-444d-a4bf-debf7e6603ce", // gitleaks:allow
    name: "Future Care",
  },
];

export const timePassedSinceEvent = (eventDate) => {
  var currentDate = new Date();
  var eventUTC = new Date(eventDate); // Convert eventDate to UTC
  var timeDiff = currentDate - eventUTC;

  // Convert milliseconds to seconds, minutes, hours, days, months, and years
  var seconds = Math.floor(timeDiff / 1000);
  var minutes = Math.floor(seconds / 60);
  var hours = Math.floor(minutes / 60);
  var days = Math.floor(hours / 24);
  var months = Math.floor(days / 30);
  var years = Math.floor(months / 12);
  // Determine the appropriate time format based on the elapsed time
  if (years > 0) {
    return years + (years === 1 ? " year" : " years");
  } else if (months > 0) {
    return months + (months === 1 ? " month" : " months");
  } else if (days > 0) {
    return days + (days === 1 ? " day" : " days");
  } else if (hours > 0) {
    return hours + (hours === 1 ? " hour" : " hours");
  } else {
    return minutes + (minutes === 1 ? " minute" : " minutes");
  }
};
